module.exports = __webpack_public_path__ + "media/images/landing_page/liaa_inkubatora_atbalsts-786e887af9fb584268e2b1caffdc8fe4.webp";